import { createFileRoute } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { MillsheetCsvImportContainer } from '@/components/screens/millsheet/millsheet-csv-import-container'

export const Route = createFileRoute('/t/$tenant_id/millsheets/csv_import')({
  component: MillsheetCsvImportPage,
})

function MillsheetCsvImportPage() {
  const { tenant_id: tenantId } = Route.useParams()
  return (
    <div className="flex min-h-screen">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1">
        <MillsheetCsvImportContainer key={tenantId} tenantId={tenantId} />
      </main>
    </div>
  )
}
